var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.16 3.567c.252 0 .458.205.458.458v4.993l2.399 2.4a.458.458 0 11-.649.648L9.835 9.532a.458.458 0 01-.134-.324V4.025c0-.253.205-.458.458-.458z",
    fill: "#0DD1C5",
    stroke: "#0DD1C5",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.16 2.583a6.625 6.625 0 100 13.25 6.625 6.625 0 000-13.25zM2.617 9.208a7.542 7.542 0 1115.083 0 7.542 7.542 0 01-15.083 0z",
    fill: "#0DD1C5",
    stroke: "#0DD1C5",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTime;